import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type { RootState } from "@/shared/redux/store/store";
import { MotorSumInsuredState } from "../type";

export type MotorSumInsuredResponse = Record<string, number>;
export type MotorSumInsuredStatus = "idle" | "loading" | "succeeded" | "failed";
export type MotorSumInsuredSource = "api" | "fallback" | null;

const initialState: MotorSumInsuredState = {
  data: {},
  status: "idle",
  source: null,
  error: null,
};

const motorSumInsuredSlice = createSlice({
  name: "motorSumInsured",
  initialState,
  reducers: {
    setMotorSumInsuredLoading(state) {
      state.status = "loading";
      state.error = null;
    },
    setMotorSumInsuredSuccess(
      state,
      action: PayloadAction<{
        data: MotorSumInsuredResponse;
        source?: MotorSumInsuredSource;
      }>
    ) {
      state.data = action.payload.data;
      state.status = "succeeded";
      state.source = action.payload.source ?? "api";
      state.error = null;
    },
    setMotorSumInsuredError(state, action: PayloadAction<string>) {
      state.status = "failed";
      state.source = null;
      state.error = action.payload;
    },
    resetMotorSumInsuredState() {
      return initialState;
    },
  },
});

export const {
  resetMotorSumInsuredState,
  setMotorSumInsuredError,
  setMotorSumInsuredLoading,
  setMotorSumInsuredSuccess,
} = motorSumInsuredSlice.actions;

export const selectMotorSumInsuredState = (state: RootState) => state.motorSumInsured;

export default motorSumInsuredSlice.reducer;
